export default {"src":"/_next/static/media/docEtDent75.fcfe7b70.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};